import request from '@/utils/request'

let Api = {
  /*小程序*/
  getData(data, errorback) {
    return request._get('/shop/plus.api.app/index', data, errorback);
  },
  applyData(data, errorback) {
    return request._post('/shop/plus.api.app/index', data, errorback);
  },

}

export default Api;



// WEBPACK FOOTER //
// ./src/api/api.js